module.exports = __webpack_public_path__ + "img/image2.dee030f9.png";